import { Component } from 'react';
import { Box, Button, Container, Typography } from '@mui/material';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box component="main" sx={{ py: 12, textAlign: 'center' }}>
          <Container>
            <Typography variant="h2" component="h1" gutterBottom>
              Something went wrong.
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 3 }}>
              Please refresh the page, or return home and try again.
            </Typography>
            <Button href="/" variant="contained">
              Return home
            </Button>
          </Container>
        </Box>
      );
    }

    return this.props.children;
  }
}
